<template>
  <div>
    <!--发布工作需求-->
    <p style="text-align: center">
      <span class="systemFont0">{{ formData.jobTitle + $t("common.details") }}</span>
    </p>
    <div class="main">
      <el-form
        ref="formDataRef"
        :model="formData"
        label-position="left"
        style="width:90%;text-align: left;margin-bottom: 20px"
      >
        <el-row>
          <!--  工作需求标题-->
          <el-col :offset="2" :span="22">
            <!--基础信息-->
            <span class="Vertical"></span><span class="title">{{ $t("demandMgt.basicInformation") }}</span>
            <br/>
            <el-form-item
              :label="$t('demandMgt.jobTitle')+$t('common.colon')"
              prop="jobTitle"
            ><span>{{ formData.jobTitle }}</span>
            </el-form-item>
          </el-col>
          <!--  工作需求内容  -->
          <el-col :offset="2" :span="22">
            <el-form-item
              :label="$t('demandMgt.jobDescription')+$t('common.colon')"
              prop="jobDescription"
            >
              <span style="white-space: pre-wrap;">{{ formData.jobDescription }}</span>
            </el-form-item>
          </el-col>
          <el-col :offset="2" :span="22">
            <!-- 需要人数 -->
            <el-col :span="6">
              <el-form-item :label="$t('demandMgt.numberOfWorkers')+$t('common.colon')" prop="numberOfWorkers">
                <span>{{ formData.numberOfWorkers }}</span>
              </el-form-item>
            </el-col>
            <!-- 工作时间 -->
            <el-col :span="18">
              <el-form-item
                :label="$t('demandMgt.jobTime')+$t('common.colon')"
                prop="startTime"
              >
                <span>{{
                    dateFormat(formData.startTime, "YYYY-MM-DD HH:mm") + (formData.endTime ? ' - ' + dateFormat(formData.endTime, "YYYY-MM-DD HH:mm") : '')
                  }}</span>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :offset="2" :span="22">
            <!-- 发送人数 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('demandMgt.countSend')+$t('common.colon')"
                prop="countSend"
              >
                <span>{{ formData.countSend }}</span>
              </el-form-item>
            </el-col>
            <!-- 标签 -->
            <el-col :span="18">
              <el-form-item ref="tagListRef" :label="$t('p0213.tag')+$t('common.colon')" prop="tagList">
                <span>{{ selectedTagsString() }}</span>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :offset="2" :span="22">
            <!-- 接受工作人数 -->
            <el-col :span="6">
              <el-form-item ref="tagListRef" :label="$t('demandMgt.countAccept')+$t('common.colon')" prop="tagList">
                <span>{{ formData.countAccept }}</span>
              </el-form-item>
            </el-col>
            <!-- 区域 -->
            <el-col :span="9">
              <el-form-item
                :label="$t('p0213.region')+$t('common.colon')"
                prop="country"
              >
                <RegionSelection ref="RegionSelectionRef" :detail="true" :disabled="disableFlag()"
                                 :formData="formData"/>
              </el-form-item>
            </el-col>
            <!-- 分区 -->
            <el-col :span="9">
              <el-form-item :label="$t('demandMgt.subarea')+$t('common.colon')" prop="subarea">
                <span>{{ formData.subarea }}</span>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <!--人员表格-->
      <el-row style="overflow: auto;text-align: left;width:90%;">
        <!--接收工作人员-->
        <el-col :offset="2" :span="22">
          <span class="Vertical"></span><span class="title">{{ $t("demandMgt.receivingStaff") }}</span>
          <el-table
            ref="tableDataRef"
            :data="tableData"
            tooltip-effect="dark"
          >
            <!-- 头像 -->
            <!-- <el-table-column
              :label="$t('newYouHuiMa.avatar')"
              align="center"
              min-width="60"
            >
              <template slot-scope="scope">
                <el-avatar
                  :key="scope.row.headPortrait"
                  :size="30"
                  :src="viewHeadPortrait(scope.row.headPortrait)"
                ></el-avatar>
              </template>
            </el-table-column> -->
            <!-- 姓名-->
            <el-table-column
              :label="$t('newYouHuiMa.name')"
              fixed="left"
              align="left"
              min-width="120"
            >
              <!-- 姓名 -->
              <template slot-scope="scope">
                {{ scope.row.lastName + " " + scope.row.firstName }}
              </template>
            </el-table-column>
            <!-- 手机号码 -->
            <el-table-column
              :label="$t('newYouHuiMa.phoneNumber')"
              align="center"
              min-width="136"
            >
              <!-- 手机号码 -->
              <template slot-scope="scope">
                {{
                  scope.row.phoneNo === null
                    ? scope.row.supplyPhoneNumber
                    : scope.row.phoneArea + " " + scope.row.phoneNo
                }}
              </template>
            </el-table-column>
            <!-- 邮箱 -->
            <el-table-column
              :label="$t('emailGroup.email')"
              align="left"
              min-width="224"
            >
              <template slot-scope="scope">
                {{ scope.row.email || scope.row.supplyEmail }}
              </template>
            </el-table-column>
            <!-- 标签 -->
            <el-table-column
              :label="$t('resourceUserQuery.tag')"
              align="left"
              min-width="156"
              prop="tag"
            >
            </el-table-column>
            <!-- 区域 -->
            <el-table-column
              prop="region"
              :label="$t('resourceUserQuery.region')"
              align="left"
              min-width="200"
            >
              <template slot-scope="scope">
                <div :style="scope.row.regionFlag === '1'?'color:red':''" v-for="(item,index) in scope.row.userLocationList" :key="'region'+index">
                  {{item.countryName}}{{item.provinceName}}{{item.cityName}}{{item.areaName}}
                </div>
              </template>
            </el-table-column>
            <!-- 分区 -->
            <el-table-column
              :label="$t('resourceUserQuery.subarea')"
              align="left"
              min-width="184"
              prop="subarea"
            >
            </el-table-column>
            <!-- 接受时间 -->
            <el-table-column
              :label="$t('demandMgt.acceptTime')"
              align="center"
              min-width="150"
              fixed="right"
            >
              <template slot-scope="scope">
                {{ dateFormat(scope.row.acceptTime, "YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 返回 -->
      <el-row class="foot-container">
        <!-- 返回 -->
        <el-button style="margin-bottom: 30px" type="return" @click="returnPage()"><span>{{ $t("common.back") }}</span>
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import RegionSelection from "./RegionSelection.vue"
import moment from "moment/moment";

export default {
  computed: {
    moment() {
      return moment
    }
  },
  components: {
    RegionSelection,
  },
  data() {
    return {
      activeName: "first",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      formData: {
        jobTitle: '',
        jobDescription: '',
        numberOfWorkers: '',
        startTime: null,
        endTime: null,
        tagList: [],
        country: '',
        province: '',
        city: '',
        area: '',
        demandUserList: [],
        selectedDemandUserList: []
      },
      selection: [],
      tableData: [],
      showFlag: false,
      tagOpList: [],
      titleHead: ""
    };
  },
  // 监听
  watch: {},
  methods: {
    // 格式化发起日期
    dateFormat(time, format) {
      if (time) {
        return moment(time).format(format);
      } else {
        return "-";
      }
    },
    selectedTagsString() {
      // 根据 formData.tagList 中的项去 tagOpList 中筛选对应的项，并生成显示的字符串
      return this.formData.tagList
        .map(tag => {
          const selectedTag = this.tagOpList.find(item => item.codeKey === tag);
          return selectedTag ? selectedTag.codeValue : '';
        })
        .filter(Boolean) // 过滤掉空值
        .join('；'); // 以逗号分隔
    },
    disableFlag() {
      return this.formData.status === 1;
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 初始化
    async init() {
      let url = "/api/demand/getDetail";
      await this.$http
        .post(url, this.formData)
        .then(async response => {
          if (response.data.code === 200) {
            this.formData = response.data.data
            this.tableData = response.data.data.selectedDemandUserList
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取option
    async getTagOption() {
      let url = "/api/demand/getTagOption";
      await this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.tagOpList = response.data.data
          }
        })
        .catch(error => {
          loading.close();
          console.log(error);
        });
    },
    // 返回
    returnPage() {
      this.$router.push({
        path: "/views/ResourceBaseManagement/DemandMgt/Index",
        query: {
          ...this.$route.query
        }
      });
    },
  }
  ,
  async mounted() {
    if (this.$route.query.demandId) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      this.formData.demandId = this.$route.query.demandId;
      await this.init()
      await this.$refs.RegionSelectionRef.getChineArea()
      await this.getTagOption()
      loading.close()
    } else {
      await this.$refs.RegionSelectionRef.getChineArea()
      await this.getTagOption()
    }
  }
}
;
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  //display: flex;
}

.foot-container {
  margin-top: 5%;
  // margin-left: 38%;
  margin: 5% auto;
  width: 20%;
  text-align: center;
}

>>> .el-table__row {
  height: 42px;
}

> .el-table .cell {
  line-height: 28px;
}

>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .buttonReset {
  width: 61px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}

.Vertical {
  position: relative;
  margin-right: 10px;

  &:before {
    content: "";
    position: absolute;
    width: 4px;
    height: 14px;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgb(44, 157, 238);
  }
}

>>> .el-form-item {
  margin-bottom: 0px;
}

.title {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/ResourceBaseManagement/DemandMgt/Detail.vue